// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as R from 'ramda'
import { forkJoin, of } from 'rxjs'
import { filter, mergeMap, switchMap, tap } from 'rxjs/operators'

import { DATA_USER_CONNECT } from '@weblite/action/gateway'
import { DATA_AUTH_SIGNOUT } from '@weblite/action/auth'
import { sendBecomeOnline } from '@weblite/ts-action/gateway'

import { serverSub } from '$func/subscription'
import { useObservable } from '$func/effectUtils'
import {
  dispatchSetConnectionStatus,
  SET_CONNECTION_STATUS,
} from '$comp/main/root.action'
// import { connectionReport } from './helper'
import { retryUntilSucceedWithCancel$ } from '$func/retryFunction'
import { changeConnectionStatus, sendNow } from '$setup/ws'
import { Feature, features } from '$setup/features'
import { delayedSyncFuncs, immediateSyncFuncs } from './sync-functions'
import afterSignOut from '../../hooks/after/signout'

serverSub.subscribeToAll(
  useObservable(action$ =>
    action$.pipe(
      filter(R.propEq('type', DATA_USER_CONNECT)),
      tap(() => {
        dispatchSetConnectionStatus('updating')
        // connectionReport.setUpdating()
      }),
      switchMap(() =>
        of(immediateSyncFuncs).pipe(
          mergeMap(syncFuncs =>
            forkJoin(
              syncFuncs.map(syncFunc =>
                retryUntilSucceedWithCancel$(
                  syncFunc,
                  action$.pipe(filter(R.propEq('type', SET_CONNECTION_STATUS))),
                ),
              ),
            ),
          ),
        ),
      ),
      tap(() => {
        // const { duration, updating } = connectionReport.getReportAndClear()
        // analite('CONNECTION', { D: duration, U: updating })
        dispatchSetConnectionStatus('connected')

        if (features.has(Feature.DELAYED_ONLINE_STATUS)) {
          sendNow(sendBecomeOnline)
        }

        delayedSyncFuncs.forEach(func => func())
        changeConnectionStatus()
      }),
    ),
  ),
)

serverSub.subscribe(DATA_AUTH_SIGNOUT, afterSignOut)
